import { Badge, Button } from '@mantine/core';
import { IconFilter, IconFilterOff } from '@tabler/icons-react';
import { iconProps } from 'components/icon-props';
import { i18nKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';

type FilterButtonProps = {
  activeFiltersCount: number;
  openFilters: VoidFunction;
  resetFilters: VoidFunction;
};

export const FilterButton = ({
  activeFiltersCount,
  openFilters,
  resetFilters,
}: FilterButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button.Group>
      <Button
        variant="default"
        onClick={openFilters}
        leftSection={<IconFilter {...iconProps()} />}
        rightSection={activeFiltersCount > 0 && <Badge color="purple">{activeFiltersCount}</Badge>}
      >
        {t(i18nKeys.FILTER)}
      </Button>
      <Button disabled={activeFiltersCount === 0} variant="default" onClick={resetFilters}>
        <IconFilterOff {...iconProps()} />
      </Button>
    </Button.Group>
  );
};
